import { useState } from "react";
import useHttp from "./useHttp";
import moment from "jalali-moment";

const useUser = () => {
  const { HttpService } = useHttp();
  const [userLoading, setUserLoadings] = useState({
    getUserSkills: true,
    getUserStats: false,
  });
  const [userSkills, setUserSkills] = useState([]);
  const [userStats, setUserStats] = useState(null);

  // get profile skills -------------------------------------------------------------------------
  const getUserSkills = async () => {
    let dataModel = [];
    try {
      const response = await HttpService.post("/api/v1.0/profile/skills");
      response.data.forEach((dataa) => {
        let newObj = {
          skill: dataa.title_persian,
          items: {
            brands: [],
            types: [],
            problems: [],
          },
        };
        dataa?.pivot?.answerQuestions?.forEach((item) => {
          if (item.question_name === "brand") {
            newObj.items.brands.push(item.answer_title);
          }
          if (item.question_name === "type") {
            newObj.items.types.push(item.answer_title);
          }
          if (item.question_name === "problem") {
            newObj.items.problems.push(item.answer_title);
          }
        });
        dataModel.push(newObj);
      });
      setUserSkills(dataModel);
    } catch ({ err, response }) {}
  };

  const getUserStats = async (technician_id, service_id) => {
    try {
      setUserLoadings({ ...userLoading, getUserStats: true });
      const response = await HttpService.get(
        "/api/v1.1/technician_evaluation/",
        {
          params: {
            technician_id: technician_id ? technician_id : "",
            service_id: service_id ? service_id : "",
            from: moment
              .from(
                moment()
                  .locale("fa")
                  .subtract(1, "months")
                  .startOf("month")
                  .format("YYYY-MM-DD HH:mm:ss"),
                "fa",
                "YYYY-MM-DD HH:mm:ss"
              )
              .format("YYYY-MM-DD HH:mm:ss"),

            to: moment
              .from(
                moment()
                  .locale("fa")
                  .subtract(1, "months")
                  .endOf("month")
                  .format("YYYY-MM-DD HH:mm:ss"),
                "fa",
                "YYYY-MM-DD HH:mm:ss"
              )
              .format("YYYY-MM-DD HH:mm:ss"),
          },
        }
      );
      setUserLoadings({ ...userLoading, getUserStats: false });
      setUserStats(response.data.data);
    } catch ({ err, response }) {
      setUserLoadings({ ...userLoading, getUserStats: false });
      setUserStats(null);
    }
  };

  const exports = {
    getUserSkills,
    getUserStats,
    userSkills,
    userStats,
    userLoading,
  };
  return exports;
};
export default useUser;
